import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import Avatar from 'flarum/common/components/Avatar';
import humanTime from 'flarum/common/helpers/humanTime';
import { rowActions } from '../notifications/rowActions.js';
import { markForumNotificationRead } from '../notifications/markForumNotificationRead.js';
function storedUser(actor) {
  if (!actor || actor.id == null || !app.store || typeof app.store.getById !== 'function') {
    return null;
  }
  return app.store.getById('users', actor.id);
}
function actorModel(actor) {
  if (!actor || actor.id == null) return null;
  return storedUser(actor) || {
    id: () => actor.id,
    username: () => actor.username,
    displayName: () => actor.displayName
  };
}
export default class NotificationInboxRow {
  oncreate(vnode) {
    vnode.dom.addEventListener('click', event => {
      if (event.target.closest('.NotificationInboxRow-target')) {
        markForumNotificationRead(app.store, vnode.attrs.row);
      }
    });
  }
  view(vnode) {
    const row = vnode.attrs.row;
    const actions = rowActions(row);
    const user = actorModel(row.actor);
    const profile = user && app.route ? app.route.user(user) : null;
    const when = row.activityAt ? humanTime(new Date(row.activityAt)) : '';
    return m("article", {
      className: 'NotificationInboxRow' + (row.unreadCount > 0 ? ' is-unread' : '')
    }, row.actor ? m(Link, {
      className: "NotificationInboxRow-actor",
      href: profile,
      "aria-label": row.actor.displayName || row.actor.username
    }, storedUser(row.actor) ? m(Avatar, {
      user: storedUser(row.actor)
    }) : m("span", {
      className: "Avatar NotificationInboxRow-fallback",
      "aria-hidden": "true"
    }, (row.actor.displayName || row.actor.username || '?').slice(0, 1))) : m("span", {
      className: "NotificationInboxRow-actor",
      "aria-hidden": "true"
    }), m("div", {
      className: "NotificationInboxRow-body"
    }, actions.primary?.href ? m(Link, {
      className: "NotificationInboxRow-target",
      href: actions.primary.href
    }, m("span", {
      className: "NotificationInboxRow-title"
    }, row.title), when ? m("time", {
      className: "NotificationInboxRow-time"
    }, when) : null) : m("div", {
      className: "NotificationInboxRow-target",
      "data-target": "unavailable"
    }, m("span", {
      className: "NotificationInboxRow-title"
    }, row.title), when ? m("time", {
      className: "NotificationInboxRow-time"
    }, when) : null), actions.message ? m("button", {
      type: "button",
      className: "Button Button--flat NotificationInboxRow-message",
      "aria-label": actions.message.label,
      onclick: () => {
        const target = actorModel(row.actor);
        if (app.flatrateMessaging && target) {
          app.flatrateMessaging.openDirectToUser(target);
        }
      }
    }, "Message") : null));
  }
}
flarum.reg.add('flatrate-messaging-ui', 'forum/components/NotificationInboxRow', NotificationInboxRow);